// src/components/Login.js
import React, {useEffect, useState} from 'react';
import Config from "./core/config";
import {useNavigate, useSearchParams} from "react-router-dom";
import {applySessionCookies, clearCurrentSession, ensureSessionIsActive} from "./utils/session";

const apiUrl = Config.apiUrl;

const applyLoginSuccess = (userData, navigate) => {
    const token = userData.token;
    if (!token) {
        return 'Resposta de login inválida (sem token).';
    }
    const {token: _t, ...userForCookie} = userData;
    applySessionCookies(token, userForCookie);
    navigate('/app');
    window.location.reload();
    return null;
};

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState(null);
    const [hashLoginPending, setHashLoginPending] = useState(false);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const hashParam = searchParams.get('hash');

    useEffect(() => {
        if (hashParam) {
            return undefined;
        }
        if (ensureSessionIsActive()) {
            navigate('/app', {replace: true});
        }
    }, [hashParam, navigate]);

    useEffect(() => {
        if (!hashParam) {
            return undefined;
        }
        let cancelled = false;
        setHashLoginPending(true);
        setLoginError(null);
        (async () => {
            try {
                clearCurrentSession();
                const response = await fetch(
                    `${apiUrl}/api/users/login-by-hash?hash=${encodeURIComponent(hashParam)}`
                );
                if (!response.ok) {
                    const msg = await response.text();
                    if (!cancelled) {
                        setLoginError(msg || 'Convite inválido ou expirado.');
                        navigate('/login', {replace: true});
                    }
                    return;
                }
                const userData = await response.json();
                const err = applyLoginSuccess(userData, navigate);
                if (!cancelled && err) {
                    setLoginError(err);
                }
            } catch (error) {
                console.error('Erro ao fazer login por convite:', error);
                if (!cancelled) {
                    setLoginError('Erro ao validar o convite. Tente novamente.');
                    navigate('/login', {replace: true});
                }
            } finally {
                if (!cancelled) {
                    setHashLoginPending(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [hashParam, navigate]);

    const handleLogin = async () => {
        try {

            if (!email || email === '') {
                setLoginError('Informe o e-mail.');
                return;
            }

            if (!password || password === '') {
                setLoginError('Informe a senha.');
                return;
            }


            const basicAuthToken = btoa(`${email}:${password}`); // Cria o token Basic Auth

            const response = await fetch(`${apiUrl}/api/users/login`, {
                method: 'GET',
                headers: {
                    'Authorization': `Basic ${basicAuthToken}`
                },
            });

            if (response.ok) {
                const userData = await response.json();
                const err = applyLoginSuccess(userData, navigate);
                if (err) {
                    setLoginError(err);
                    return;
                }
                setLoginError(null);
            } else {
                setLoginError( 'E-mail ou senha inválidos');
            }
        } catch (error) {
            console.error('Erro ao fazer login:', error);
            setLoginError('Erro ao fazer login. Tente novamente mais tarde.');
        }
    };

    const field = {
        width: '100%',
        boxSizing: 'border-box',
    };
    const label = {fontSize: 14, fontWeight: 600, marginTop: 12, marginBottom: 4, color: 'var(--color-text-muted)'};

    return (
        <div className="login-page">
            <div className="login-card">
                <h2 style={{marginTop: 0, fontSize: 22}}>Login</h2>
                {hashLoginPending && (
                    <div style={{textAlign: 'center', padding: '24px 8px'}}>
                        <p style={{color: 'var(--color-text)', fontSize: 16, margin: 0}}>Entrando…</p>
                        <p style={{color: 'var(--color-text-muted)', fontSize: 12, margin: '8px 0 0'}}>Convite QR</p>
                    </div>
                )}
                <form style={{display: hashLoginPending ? 'none' : 'block'}}>
                    <div style={label}>Login</div>
                    <input
                        style={field}
                        type="text"
                        inputMode="email"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <div style={label}>Senha</div>
                    <input
                        style={field}
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div style={{marginTop: 18}}>
                        <button
                            style={{...field, margin: 0}}
                            className="confirm-button"
                            type="button"
                            onClick={handleLogin}
                        >
                            Acessar
                        </button>
                    </div>
                </form>
                {loginError && (
                    <p style={{color: 'var(--color-danger)', fontSize: 14, marginTop: 12}}>{loginError}</p>
                )}
            </div>
        </div>
    );
};

export default Login;
